// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"654":"f66ffe2f4c7ffed6","670":"5d061070d4154bf3","772":"396291aca92a0f13","844":"0480e77c88f939de","880":"00fdc9fc373ec097"}[chunkId] + ".js";
};